import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DewarDataDTO } from 'components/synchrotron/constants';

const initialState: DewarDataDTO[] = Array<DewarDataDTO>();
const DewarSlice = createSlice({
  name: 'dewars',
  initialState,
  reducers: {
    setAllDewars: (state, action: PayloadAction<DewarDataDTO[]>) => {
      return action.payload;
    },
  },
});

export const { setAllDewars } = DewarSlice.actions;

export default DewarSlice.reducer;
